import { useRouter } from 'next/router';

import React, { useEffect, useState } from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import MaskedInput from 'react-text-mask';

import ContactFormData from '../../../types/components/contactForm';
import { Toast, ToastColor } from '../../../utils/toastNotification';
import { validationFormContact } from '../../../utils/validationForm';

import style from './cadastroDefault.module.scss';

export default function CadastroForm() {
  const [errorMessage, setErrorMessage] = useState('');

  const initialState = {
    empreendimento: useRouter().asPath ?? '',
    email: '',
    nome: '',
    telefone: '',
    momento: '',
    horario: '',
    canal: '',
    criadoEm: new Date(),
  };
  const [contactFormData, setContactFormData] = useState<ContactFormData>(initialState);

  useEffect(() => {
    const script = document.createElement('script');

    script.src = 'https://d335luupugsy2.cloudfront.net/js/rdstation-forms/stable/rdstation-forms.min.js';
    script.async = true;
    document.body.appendChild(script);
  }, []);

  const handleSubmit = async(event) => {
    event.preventDefault();
    const { error } = await validationFormContact.validate(contactFormData);

    if (error) {
      setErrorMessage(error.details[0].message);
      setTimeout(() => {
        setErrorMessage('');
      }, 5000);
    } else {
      try {
        new Toast({
          message: 'Enviado com sucesso!',
          color: ToastColor.Success,
          time: 5000,
        });

        const form = document.getElementById('form') as HTMLFormElement;

        form.reset();
        setContactFormData(initialState);
      } catch (err) {
        new Toast({
          message: 'Erro no envio. Entre em contato conosco!',
          color: ToastColor.Danger,
          time: 5000,
        });
      }
    }
  };
  const canais = ['E-mail', 'Telefone', 'WhatsApp'];

  return (
    <div
      className={style.formContainer}
      id='formContainer'>
      <h3>Quer saber mais?</h3>
      <p className={style.subtitle}>Entre em contato em receba as informações!</p>
      <form
        onSubmit={handleSubmit}
        id='form'
        name={useRouter().asPath}>
        <div className={style.fieldItem}>
          <input
            type='text'
            onChange={(e) => setContactFormData({
              ...contactFormData,
              nome: e.target.value,
            })}
            id='nome'
            name='nome'
            required
          />
          <label htmlFor='nome'>Nome Completo</label>
        </div>
        <div className={style.fieldItem}>
          <input
            type='email'
            onChange={(e) => setContactFormData({
              ...contactFormData,
              email: e.target.value,
            })}
            id='email'
            name='email'
            required
          />
          <label htmlFor='email'>Email</label>
        </div>
        <div className={style.fieldItem}>
          <MaskedInput
            mask={['(', /[1-9]/, /\d/, ')', ' ', /\d?/, ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
            onChange={(e) => setContactFormData({
              ...contactFormData,
              telefone: e.target.value,
            })}
            id='telefone'
            name='telefone'
            required
          />
          <label htmlFor='telefone'>Telefone</label>
        </div>
        <div className={style.fieldItem}>
          <select
            onChange={(e) => setContactFormData({
              ...contactFormData,
              momento: e.target.value,
            })}
            aria-label='Momento'
            id='momento'
            name='momento'
            required>
            <option
              selected
              value=''
              aria-label='option'
            />
            <option value='Pronto para uma proposta'>Pronto para uma proposta</option>
            <option value='Apenas Pesquisando'>Apenas pesquisando</option>
            <option value='Visitando imóveis'>Visitando imóveis</option>
          </select>
          <label htmlFor='momento'>Você está...</label>
        </div>
        <div className={style.fieldItem}>
          <input
            type='text'
            onChange={(e) => setContactFormData({
              ...contactFormData,
              horario: e.target.value,
            })}
            id='horario'
            name='horario'
            placeholder='Ex.: Após 10h da manhã'
          />
          <label htmlFor='horario'>Melhor horário para contato</label>
        </div>
        <div className={style.fieldCanal}>
          <h4>Canal preferencial de contato</h4>
          <div>
            {canais.map((can) => (
              <label
                key={can}
                htmlFor={can}>
                <input
                  type='checkbox'
                  onChange={() => setContactFormData({
                    ...contactFormData,
                    canal: can,
                  })}
                  id={can}
                  name='canal'
                  aria-label={`${can} como melhor canal de contato`}
                  checked={can === contactFormData.canal}
                />
                {can}
              </label>
            ))}
          </div>
        </div>
        <div className={style.errorMessage}>{errorMessage}</div>
        <button
          aria-label='Enviar formulário de contato'
          type='submit'>
          Enviar
        </button>
        <div className={style.contacts}>
          <h3>Central de Vendas</h3>
          <a
            href={`https://api.whatsapp.com/send?l=pt_BR&phone=${process.env.NEXT_PUBLIC_ZAPIER_PHONE_NUMBER}&text=Olá! Tenho interesse em conhecer empreendimentos da Hype!`}>
            <FaWhatsapp className={style.iconContact} />
            <span>(41) 99859-0963</span>
          </a>
        </div>
      </form>
    </div>
  );
}
